import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  max-width: 1200px;
  display: flex;
  overflow-x: auto;
  flex-direction: column;

  h1 {
    text-align: left;
    color: #000;
  }

  @media (max-width: 750px) {
    padding: 10px 0;
    h1 {
      text-align: left;
      font-size: 22px;
      margin-bottom: 10px;
    }
  }

  .filters-row {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
    margin-bottom: 20px;
    background: #fff;
    padding: 20px;
    border-radius: 15px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    border: 1px solid #f0f0f0;
    align-items: flex-end;
  }

  /* Novo Estilo de Listagem */
  .payments-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
    padding: 0 5px;
    margin-top: 25px;
  }

  .payment-card {
    background: #fff;
    padding: 15px 20px;
    border-radius: 12px;
    border: 1px solid #f0f0f0;
    display: grid;
    grid-template-columns: 1.5fr 1fr 1fr 1fr 1.2fr 60px;
    gap: 15px;
    align-items: center;
    transition: all 0.2s ease;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.02);
    width: 100%;

    &:hover {
      border-color: #008037;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
      transform: translateX(3px);
    }

    @media (max-width: 1100px) {
      grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
      gap: 15px;
      padding: 20px;
    }

    .main-info {
      display: flex;
      flex-direction: column;
      strong {
        font-size: 14px;
        color: #333;
      }
      span {
        font-size: 11px;
        color: #008037;
        font-weight: bold;
      }
    }

    .info-item {
      display: flex;
      flex-direction: column;
      font-size: 12px;
      color: #666;
      label {
        font-size: 10px;
        text-transform: uppercase;
        color: #bbb;
        margin-bottom: 2px;
      }
      span {
        font-weight: 500;
      }
    }

    .actions {
      display: flex;
      justify-content: flex-end;
      gap: 8px;

      button {
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        padding: 0 !important;
      }
    }
  }
`;

export const Label = styled.span`
  width: 10px;
  height: 10px;
  border-radius: 2px;
  display: inline-block;
  background: ${(props) => props.color};
`;

export const AssociateInfo = styled.div`
  background: #f8faf9;
  border: 1px solid #d7f0db;
  border-radius: 10px;
  padding: 15px;
  margin-top: 20px;
  display: flex;
  gap: 15px;
  align-items: center;

  img {
    width: 60px !important;
    height: 60px !important;
    border-radius: 8px !important;
    object-fit: cover;
    margin: 0 !important;
  }

  .info {
    display: flex;
    flex-direction: column;

    strong {
      font-size: 14px;
      color: #333;
    }
    span {
      font-size: 12px;
      color: #666;
    }
  }
`;

export const InfoTag = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 15px 0;

  .tag {
    background: #f0f0f0;
    padding: 4px 12px;
    border-radius: 50px;
    font-size: 11px;
    color: #555;
    border: 1px solid #e0e0e0;
    display: flex;
    align-items: center;
    gap: 5px;
  }
`;
